(() => {
  function initialize(root) {
    if (!root || root.dataset.gelatoReady) return;
    root.dataset.gelatoReady = '1';
    const choices = [...root.querySelectorAll('[data-gl-color]')];
    const stage = root.querySelector('[data-gl-stage]');
    const image = root.querySelector('.gl-stage__image');
    choices.forEach(choice => choice.addEventListener('click', () => {
      choices.forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
      if (image) {
        image.setAttribute('style', choice.dataset.imageStyle || '');
        image.alt = choice.dataset.title;
        image.srcset = choice.dataset.srcset;
        image.src = choice.dataset.image;
      }
      if (stage) stage.style.setProperty('--gl-glow', choice.dataset.glow);
      root.querySelector('[data-gl-selected-name]').textContent = choice.dataset.name;
      root.querySelector('[data-gl-selected-price]').textContent = choice.dataset.price;
      root.querySelector('[data-gl-selected-position]').textContent = choice.dataset.index.padStart(2, '0') + ' / ' + choice.dataset.total;
      root.querySelectorAll('[data-gl-model-link]').forEach(link => { link.href = choice.dataset.url; });
    }));
    root.querySelectorAll('[data-gl-card]').forEach(card => {
      const variants = JSON.parse(card.querySelector('[data-gl-variants]').textContent);
      const select = card.querySelector('[data-gl-size]');
      const input = card.querySelector('.product-variant-id');
      const button = card.querySelector('.gl-add');
      const label = button.querySelector('.gl-add__label');
      const sold = button.querySelector('.sold-out-message');
      const price = card.querySelector('[data-gl-price]');
      select.addEventListener('change', () => {
        const variant = variants.find(option => String(option.id) === select.value);
        const available = Boolean(variant?.available);
        input.value = variant ? String(variant.id) : '';
        button.disabled = !available;
        if (available) button.removeAttribute('aria-disabled');
        else button.setAttribute('aria-disabled', 'true');
        label.classList.remove('hidden');
        sold.classList.add('hidden');
        label.textContent = variant ? (available ? root.dataset.addLabel : root.dataset.soldLabel) : root.dataset.pickLabel;
        if (variant) price.textContent = variant.price;
        const error = card.querySelector('.product-form__error-message-wrapper');
        if (error) error.hidden = true;
      });
    });
  }
  document.querySelectorAll('[data-gelato-studio]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-gelato-studio]').forEach(initialize);
  });
})();
